export default __webpack_public_path__ + "static/media/OpenSans-ExtraBold.0a657763.woff";